import React from 'react'
import { useHistory } from 'react-router-dom'
import { Element } from 'react-scroll'
import { FormattedMessage } from 'react-intl'
import { Button, Row, Col } from '@gympass/yoga'

import { SmallBusiness, MediumBusiness, LargeBusiness } from '@assets/icons'

import useDataLayer from '@hooks/useDataLayer'
import useRouteBuilder from '@hooks/useRouteBuilder'

import Container from '../../Home.style'
import * as Style from './CompanyPlans.style'

export default function CompanyPlans() {
  const { events, values } = useDataLayer()
  const history = useHistory()
  const { buildRoute } = useRouteBuilder()

  function handleDataLayerEvent(label) {
    events.simulatorInteraction(label)

    if (label !== values.LARGE_BUSINESS_PLAN_CARD) {
      history.push(buildRoute('simulate/company-info'))
    }
  }

  return (
    <Element name="company-plans">
      <Style.Wrapper>
        <Container>
          <Row>
            <Col xxs={11} xl={12}>
              <Style.Title>
                <FormattedMessage
                  id="smb_acquisition_home.company_plans.title"
                  values={{
                    span: (...chunks) => <span>{chunks}</span>,
                  }}
                />
              </Style.Title>
            </Col>
          </Row>

          <Row>
            <Col xxs={12}>
              <Style.Subtitle>
                <FormattedMessage id="smb_acquisition_home.company_plans.subtitle" />
              </Style.Subtitle>
            </Col>
          </Row>
        </Container>

        <Style.CardWrapper>
          <Style.Card>
            <Style.CardIcon
              src={SmallBusiness}
              alt="A small store with only one door"
            />

            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_1.title" />
            </Style.CardTitle>

            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_1.subtitle" />
            </Style.CardSubtitle>

            <Style.PriceWrapper>
              <Style.PriceCurrency>$</Style.PriceCurrency>

              <Style.Price>
                <FormattedMessage id="smb_acquisition_home.company_plans.plan_1.value" />
              </Style.Price>

              <Style.PriceHelper>
                /
                <FormattedMessage id="smb_acquisition_commons.frequency.monthly" />
              </Style.PriceHelper>
            </Style.PriceWrapper>

            <Button
              full
              onClick={() =>
                handleDataLayerEvent(values.SMALL_BUSINESS_PLAN_CARD)
              }
            >
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_1.call_to_action.default_smb" />
            </Button>
          </Style.Card>

          <Style.Card>
            <Style.CardIcon
              src={MediumBusiness}
              alt="A medium business with three floors"
            />

            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_2.title" />
            </Style.CardTitle>

            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_2.subtitle" />
            </Style.CardSubtitle>

            <Style.PriceDescription>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_2.value" />
            </Style.PriceDescription>

            <Button
              full
              onClick={() =>
                handleDataLayerEvent(values.MEDIUM_BUSINESS_PLAN_CARD)
              }
            >
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_2.call_to_action.default_smb" />
            </Button>
          </Style.Card>

          <Style.Card>
            <Style.CardIcon src={LargeBusiness} alt="A big mall" />
            <Style.CardTitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_3.title" />
            </Style.CardTitle>
            <Style.CardSubtitle>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_3.subtitle" />
            </Style.CardSubtitle>
            <Style.PriceDescription>
              <FormattedMessage id="smb_acquisition_home.company_plans.plan_3.value" />
            </Style.PriceDescription>
            <Style.LargeCompaniesLink
              href="https://hs.gympass.com/en-us/contactus-lp?utm_source=website&utm_medium=button&utm_campaign=hands-up-SMB-US"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                full
                onClick={() =>
                  handleDataLayerEvent(values.LARGE_BUSINESS_PLAN_CARD)
                }
              >
                <FormattedMessage id="smb_acquisition_home.company_plans.plan_3.call_to_action.default_smb" />
              </Button>
            </Style.LargeCompaniesLink>
          </Style.Card>
        </Style.CardWrapper>
      </Style.Wrapper>
    </Element>
  )
}
